import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import { useDepositApplicationSelections } from "@/hooks/useDepositApplicationSelections";
import { useFinancialProducts } from "@/hooks/useFinancialProducts";
import { FinancialProductReadDTO } from "@/types";
import { EnumMultiSelectFieldV2, EnumMultiSelectFieldV2Value } from "@ucl/library";

export interface FinancialProductMultiSelectFormProps {
  financialApplicationId: string;
}

export const FinancialProductMultiSelectForm: React.FC<FinancialProductMultiSelectFormProps> = ({
  financialApplicationId,
}) => {
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const { products } = useFinancialProducts(financialApplicationApiClient);

  const { selectedProductIds, setSelectedProductIds } = useDepositApplicationSelections(
    financialApplicationId,
    financialApplicationApiClient,
    products
  );

  return (
    <EnumMultiSelectFieldV2
      label="Product Type(s)"
      description="Select all products to be included in the application."
      growToFit={true}
      value={selectedProductIds}
      onSubmit={(value: EnumMultiSelectFieldV2Value) => {
        value && typeof value[0] === "string"
          ? setSelectedProductIds(value.map((v) => v as string))
          : setSelectedProductIds([]);
      }}
      errorMessages={[]}
      isRequired={true}
      optionValues={products.map((product: FinancialProductReadDTO) => ({
        label: product.productName,
        value: product.id,
      }))}
      placeholder="Search and select products..."
    />
  );
};
